import { render, staticRenderFns } from "./edit-declaration-element.vue?vue&type=template&id=1946094a"
import script from "./edit-declaration-element.vue?vue&type=script&lang=ts"
export * from "./edit-declaration-element.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports